const VENUES = [
    "Bellagio Concourse",
    "Caesars Palace North Tower",
    "Fremont Experience",
    "Stratosphere Tower",
    "Cosmopolitan Level 2",
    "Venetian Canal Shoppes",
    "Mandalay Bay",
    "Wynn Esplanade",
];

export default function Marquee() {
    const row = [...VENUES, ...VENUES];
    return (
        <section
            className="relative overflow-hidden border-y border-white/5 bg-[#0D0E15]/60 py-6"
            data-testid="editorial-marquee"
            aria-hidden="true"
        >
            <div className="animate-marquee flex w-max items-center whitespace-nowrap">
                {row.map((v, i) => (
                    <span key={i} className="flex items-center">
                        <span
                            className={`font-display text-2xl font-bold uppercase tracking-wide sm:text-3xl ${
                                i % 2 === 0 ? "text-outline" : "text-white/10"
                            }`}
                        >
                            {v}
                        </span>
                        <span className="mx-8 text-lg text-neon-magenta neon-magenta">◆</span>
                    </span>
                ))}
            </div>
        </section>
    );
}
